module.exports = __webpack_public_path__ + "static/media/The-Mini-Pill-first-lithonia-medical-center.bc183e53.jpg";